import React from "react";
import { Modal, Table, Image, Tag, Space, Typography } from "antd";

const { Title } = Typography;

const DetailsModal = ({ visible, onClose, record }) => {

  const columns = [
    {
      title: 'Date Time',
      dataIndex: 'date',
      key: 'date',
      width: 180,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 170,
      render: (type) => {
        let color = 'default';
        if (type === 'Finish') color = 'success';
        if (type === 'Reject') color = 'error';
        if (type === 'RejectFix') color = 'warning';
        if (type === 'Start') color = 'processing';
        if (type === 'Assign Auto') color = 'purple';
        if (type === 'Input') color = 'cyan';
        return <Tag color={color}>{type}</Tag>;
      }
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      render: (text) => (text && text !== '-') ? <div style={{ whiteSpace: 'pre-wrap', maxHeight: 200, overflowY: 'auto' }}>{text}</div> : '-'
    },
    {
      title: 'By',
      dataIndex: 'by_name',
      key: 'by_name',
      width: 150,
      render: (text, record) => text || record.by
    },
    {
      title: 'Media',
      dataIndex: 'media',
      key: 'media',
      width: 150,
      render: (media) => {
        if (!media || !Array.isArray(media) || media.length === 0) return '-';
        return (
          <Image.PreviewGroup>
            <Space wrap>
              {media.map((url, index) => (
                <Image
                  key={index}
                  src={url}
                  width={50}
                  height={50}
                  style={{ objectFit: 'cover', borderRadius: 4, border: '1px solid #f0f0f0' }}
                />
              ))}
            </Space>
          </Image.PreviewGroup>
        );
      }
    }
  ];

  return (
    <Modal
      title={<Title level={4} style={{ margin: 0 }}>ประวัติการดำเนินงาน (Activity Log)</Title>}
      open={visible}
      onCancel={onClose}
      width={1100}
      footer={null}
      style={{ top: 20 }}
      styles={{ body: { padding: '20px' } }}
    >
      <Table
        columns={columns}
        dataSource={record?.history_logs || []}
        rowKey={(row, index) => index}
        pagination={false}
        bordered
        size="middle"
        scroll={{ y: 600 }}
      />
    </Modal>
  );
};

export default DetailsModal;